import { Box, Button, Flex, FormLabel, Heading, SimpleGrid, Text } from "@chakra-ui/react";
import { FC } from "react";
import { Link } from "react-router";

import { getLoginLogoutUrl } from "@/api/api-configuration";

import { BroCredentialsForm } from "../../features/profile/bro-credentials-form";
import { BroDomainStats } from "../../features/profile/bro-domain-stats";
import { useUser } from "../../providers/auth-provider";

const ProfileInfoItem: FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <Box pr="5">
    <FormLabel
      mb="1"
      whiteSpace="nowrap"
      textOverflow="ellipsis"
      overflow="hidden"
      fontWeight="bold"
    >
      {title}
    </FormLabel>
    <Text pb="5">{children}</Text>
  </Box>
);

const Profile: FC = () => {
  const user = useUser();

  return (
    <Flex h="full" direction="column" gap="8">
      <Flex flexDir={{ base: "column", md: "row" }}>
        <Box pr={{ base: "0", md: "10" }} width={{ md: "50%" }}>
          <Box w="100%">
            <Heading as="h2" pb="3">
              Gebruikersinformatie
            </Heading>
            <SimpleGrid flexShrink={0} columns={2}>
              <ProfileInfoItem title={"Voornaam"}>{user.firstName}</ProfileInfoItem>
              <ProfileInfoItem title={"Achternaam"}>{user.lastName}</ProfileInfoItem>
              <ProfileInfoItem title={"Gebruikersnaam"}>{user.username}</ProfileInfoItem>
              <ProfileInfoItem title={"E-mail"}>{user.email}</ProfileInfoItem>
              <ProfileInfoItem title={"Organisatie"}>{user.organisation}</ProfileInfoItem>
              <ProfileInfoItem title={"KvK"}>{user.kvk}</ProfileInfoItem>
              <ProfileInfoItem title={"Berichten verstuurd"}>
                {user.organisationCurrentRequestCount}
              </ProfileInfoItem>
              <Button
                onClick={() => window.location.replace(getLoginLogoutUrl(user.logoutUrl))}
                mr="auto"
                my="3"
                type="submit"
                variant="outlinePrimary"
                ml="0"
              >
                Log uit
              </Button>
            </SimpleGrid>
          </Box>
        </Box>

        <Box width={{ md: "50%" }} pt={{ base: "6", md: "0" }}>
          <BroCredentialsForm />
        </Box>
      </Flex>

      {/* BRO Domain Statistics Dashboard */}
      <Box>
        <BroDomainStats />
      </Box>

      <Flex flexDir={{ base: "column", md: "row" }} py="10" flexGrow={0} gap="10" align="stretch">
        <Box display="flex" flexDir="column">
          <Heading as="h3" pb="2">
            Wil je weer verder aan de slag?
          </Heading>
          <Text>Terug naar het hoofdscherm, met de kaart en tabbladen voor correcties</Text>
          <Box mt="auto" pt="5">
            <Link to="/">
              <Button mx="0" mt="5" variant="outlineGrey">
                Naar het dashboard
              </Button>
            </Link>
          </Box>
        </Box>
        <Box
          borderLeft={{ md: "solid 1px lightgrey" }}
          pl={{ md: "5" }}
          display="flex"
          flexDir="column"
        >
          <Heading as="h3" pb="2">
            Een beetje de weg kwijt?
          </Heading>
          <Flex flexDir={{ base: "column", md: "row" }} flexGrow={1} gap={{ md: "10" }}>
            <Box width={{ md: "45%" }} display="flex" flexDir="column">
              <Text>
                Op zoek naar blog posts en andere informatie? Bekijk dan ook de webpaginas over
                BROSTAR.
              </Text>
              <Box mt="auto" pt="5">
                <Link to="/public/">
                  <Button mx="0" variant="outlineGrey">
                    Naar de publieke pagina
                  </Button>
                </Link>
              </Box>
            </Box>
            <Box width={{ md: "45%" }} display="flex" flexDir="column">
              <Text>Gedetailleerde beschrijvingen over het gebruik van de API.</Text>
              <Box mt="auto" pt="5">
                <a href="https://docs.brostar.nl/" target="_blank" rel="noopener noreferrer">
                  <Button mx="0" variant="outlineGrey">
                    Naar de documentatie
                  </Button>
                </a>
              </Box>
            </Box>
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
};

export { Profile };
